import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	replacedByParentField: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	replacedByParentField: {
		id: 'issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field',
		defaultMessage: 'Replaced by <strong>Parent</strong> field',
		description:
			'Text to display on the Epic Link field indicating that the Epic Field is no longer used and the user should instead use the Parent field',
	},
});
export default messages;
